import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ButtonsUseStyles from 'consts/styles/Buttons';
import InsideLoader from 'components/common/InsideLoader';
import { getZonesFromUserSettings } from 'components/dashboard/utils/main';
import { FiltersDetailsUseStyles } from './FiltersDetailsUseStyles';

const ZonesFilter = props => {
  const { setZonesFilters, allZones, language, allLocalZones } = props;
  const [zonesTypesToShow, setZonesTypesToShow] = React.useState(
    getZonesFromUserSettings()
  );

  const [isLocalZones, setIsLocalZones] = React.useState(true);

  const classesFilters = FiltersDetailsUseStyles();
  const classesButtons = ButtonsUseStyles();

  React.useEffect(() => {
    setZonesFilters(zonesTypesToShow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocalZones]);

  const toggleSource = zone => {
    const indexOfZone = zonesTypesToShow.indexOf(zone);
    const zones = [...zonesTypesToShow];
    if (indexOfZone === -1) zones.push(zone);
    else zones.splice(indexOfZone, 1);
    setZonesFilters(zones);
    setZonesTypesToShow(zones);
  };

  const isSelected = source => !!zonesTypesToShow.includes(source);

  const publicZones = Object.keys(allZones).map(zone => (
    <Grid key={zone} item xs={6}>
      <Button
        type="button"
        className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
        variant={isSelected(zone) ? 'contained' : 'outlined'}
        onClick={() => toggleSource(zone)}
        color="primary"
      >
        {zone}
      </Button>
    </Grid>
  ));

  const localZones = Object.keys(allLocalZones).map(zone => (
    <Grid key={zone} item xs={6}>
      <Button
        type="button"
        className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
        variant={isSelected(zone) ? 'contained' : 'outlined'}
        onClick={() => toggleSource(zone)}
        color="primary"
      >
        {zone.length > 6 && zone.substring(0, zone.length - 6)}
      </Button>
    </Grid>
  ));

  return (
    <>
      {allLocalZones ? (
        <div>
          <div className={`${classesFilters.FiltersDetails}__table__details`}>
            {language.zonesDetails.type_}
            <div
              className={`${classesFilters.FiltersDetails}__table__details__container`}
            >
              <Button
                type="button"
                className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
                variant={isLocalZones ? 'contained' : 'outlined'}
                onClick={() => setIsLocalZones(true)}
                color="primary"
              >
                {language.zonesDetails.private_}{' '}
              </Button>
              <Button
                type="button"
                className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
                variant={isLocalZones ? 'outlined' : 'contained'}
                onClick={() => setIsLocalZones(false)}
                color="primary"
              >
                {language.zonesDetails.public_}
              </Button>
            </div>
          </div>

          <div className={`${classesFilters.FiltersDetails}__table__details`}>
            {language.zonesDetails.zonesListHeader_}
            <div
              className={`${
                !isLocalZones
                  ? `${classesFilters.FiltersDetails}__table__details__scroll`
                  : ''
              }`}
            >
              {isLocalZones ? (
                <div
                  className={`${classesFilters.FiltersDetails}__table__details__container`}
                >
                  {localZones}
                </div>
              ) : (
                <div
                  className={`${classesFilters.FiltersDetails}__table__details__container`}
                >
                  {publicZones.length > 0 ? (
                    publicZones
                  ) : (
                    <div
                      className={`${classesFilters.FiltersDetails}__table__details__container`}
                    >
                      <Button
                        type="button"
                        className={`${classesFilters.FiltersDetails}__table__details__container__button ${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
                        disabled
                        color="primary"
                      >
                        {language.filters.uavos.noData_}
                        
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {!allLocalZones ? <InsideLoader /> : null}
    </>
  );
};

ZonesFilter.propTypes = {
  allZones: PropTypes.object.isRequired,
  setZonesFilters: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  allLocalZones: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  allZones: state.allZones,
  language: state.language,
  allLocalZones: state.allLocalZones,
});

export default connect(mapStateToProps)(ZonesFilter);
